export default __webpack_public_path__ + "static/media/8.0aa55314.png";